import { ProjectSectionProps } from '../../model/ProjectSection';
import React, { ReactElement } from 'react';
import { Section } from '../Section';
import { Container } from '../Container';
import styled from 'styled-components';
import { Colors } from '../../constants/colors';
import { Device } from '../../constants/device';
import { partners } from '../../config/partnersConfig';
import { useTranslation } from 'react-i18next';

const logosRoot = '/partners/';

// TODO: native-speaker review of the sk/hu/hr translations of the partners.* strings.
export const Partners = (props: ProjectSectionProps): ReactElement | null => {
  const { t } = useTranslation();

  return (
    <Section id={'partners'} inverse={props.inverse} heading={t('section.partners')}>
      <Container>
        <Intro>{t('partners.intro')}</Intro>
        <PartnersContainer>
          {partners.map((partner) => (
            <PartnerItem key={partner.key}>
              <PartnerLogo href={partner.url} target="_blank" rel="noopener">
                <img src={`${logosRoot}${partner.logo}`} alt={partner.name} />
              </PartnerLogo>
              <PartnerText>{t(`partners.${partner.key}.text`)}</PartnerText>
            </PartnerItem>
          ))}
        </PartnersContainer>
      </Container>
    </Section>
  );
};

const Intro = styled.p`
  text-align: center;
  margin-bottom: 40px;
`;

// Same content width as the reference cards; additional partner cards
// stack vertically below the first one.
const PartnersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

// Mirrors the reference-card visual language (background, radius, padding).
const PartnerItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  padding: 30px;
  background: ${Colors.primary};
  color: ${Colors.white};
  border-radius: 20px;

  ${Device.tablet} {
    flex-direction: column;
    gap: 25px;
  }
`;

// White panel keeps the logo legible on the primary background.
const PartnerLogo = styled.a`
  flex: 0 0 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  background: ${Colors.white};
  border-radius: 12px;
  padding: 35px 25px;

  img {
    width: 100%;
    transition: opacity 0.3s ease;
  }

  &:hover img {
    opacity: 0.5;
  }

  ${Device.tablet} {
    flex-basis: auto;
    width: 100%;
    max-width: 280px;
  }
`;

const PartnerText = styled.div`
  flex: 1;
  text-align: start;
`;
